import localesEn from "./locales-en";
import localesEs from "./locales-es";
import localesPt from "./locales-pt";
var locales = {
  en: localesEn,
  es: localesEs,
  pt: localesPt
};
export default locales;